import SkipLinks from '@arpav/components/ArpavTheme/SkipLinks/SkipLinks';

export default SkipLinks;
